import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { ParentEventFromSearch } from "../event-page-models/parent-event-from-search";
import { EventStatus } from "../event-page-models/event-status";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { RowEventEmit } from "../event-page-models/row-event-emit";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { Router } from "@angular/router";
import { parentEventQuestionsCardSelectMenuOptions } from "../create-parent-event-form-parent-questions-card/parent-event-questions-card-select-menu-options";
import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { trimTextByWord } from "../utils/trimTextByWord";

@Component({
  selector: "parent-events-row",
  templateUrl: "./parent-events-row.component.html",
  styleUrls: ["./parent-events-row.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "1500px",
          opacity: 1,
          overflow: "visible",
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class ParentEventsRowComponent implements OnInit, OnDestroy {
  @Input("openEventCode") public openEventCode: string;
  @Output("rowEvent") public rowEvent: EventEmitter<RowEventEmit> =
    new EventEmitter<RowEventEmit>();
  @Input() public parentEvent: ParentEventFromSearch;

  public openToExtendedText: string = "";

  public eventStatusMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "open",
      text: "פתוח",
      customValue: "",
    },
    {
      icon: "",
      key: "closed",
      text: "סגור",
      customValue: "",
    },
  ];
  public parentEventStatus: SelectMenuOption = this.eventStatusMenuOptions[0];
  protected readonly parentEventQuestionsCardSelectMenuOptions =
    parentEventQuestionsCardSelectMenuOptions;

  constructor(
    private eventService: EventsService,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.parentEventStatus =
      this.parentEvent.eventStatus === EventStatus.Open
        ? this.eventStatusMenuOptions[0]
        : this.eventStatusMenuOptions[1];
  }

  ngOnDestroy(): void {}

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  clickSelect($event: Event) {
    $event.stopPropagation();
    $event.stopPropagation();
  }

  public rowClicked($event): void {
    const action =
      this.parentEvent.parentEventCode === this.openEventCode
        ? "close"
        : "open";
    this.rowEvent.emit({
      action,
      eventId: this.parentEvent.parentEventCode,
      eventObject: this.parentEvent,
    });
  }

  public changeStatus($event: any) {}

  public menuEventHandler($event: RowEventEmit) {
    switch ($event.action) {
      case "close":
      case "open":
        return;
      case "delete":
      case "duplicate":
        this.rowEvent.emit({
          action: $event.action,
          eventId: this.parentEvent.parentEventId.toString(),
          eventObject: this.parentEvent,
        });

        return;
      case "edit":
        this.rowEvent.emit({
          action: $event.action,
          eventId: this.parentEvent.parentEventId.toString(),
          eventObject: this.parentEvent,
        });

        return;
    }
  }

  public clickedChangeEventStatus($event: SelectMenuOption) {
    this.parentEvent.eventStatus =
      $event.key === "open" ? EventStatus.Open : EventStatus.Closed;

    this.changeStatus($event);
  }
  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-row/parent-events-row.component.ts